import { extractNodes } from './extractNodes';

// --- Depth Map (recursive) ---
const updateNodeDepths = (node, currentDepth, nodeDepthMap, maxDepth) => {
  if (!(node.id in nodeDepthMap) || currentDepth < nodeDepthMap[node.id]) {
    nodeDepthMap[node.id] = currentDepth;
  }
  if (currentDepth >= maxDepth) return;

  node.connections.forEach((conn) => {
    updateNodeDepths(conn.target, currentDepth + 1, nodeDepthMap, maxDepth);
  });
};

const extractNodeDepthMap = (json, maxDepth = Infinity) => {
  const nodeDepthMap = {};
  json.forEach((node) => updateNodeDepths(node, 0, nodeDepthMap, maxDepth));
  return nodeDepthMap;
};

// --- Main function ---
export const extractGraphDataWithDepth = (json, maxDepth = Infinity) => {
  const nodes = extractNodes(json);
  const nodeDepthMap = extractNodeDepthMap(json, maxDepth);
  return { nodes, nodeDepthMap };
};
